import { Component, Input } from '@angular/core';
import {
  Actions,
  ActionType,
  Paginator
} from '../../models/paginator.interface';
import { DisplayManagerService } from '../../services/display-manager.service';

@Component({
  selector: 'idp-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @Input() paginator: Paginator = {} as Paginator;

  constructor(public displayManagerService: DisplayManagerService) {}

  updateIndex(index: number, actionType: ActionType, barIndex?: number) {
    let updatedIndex = 0;
    if (actionType === 'previous') {
      updatedIndex = index - 1;
    } else if (actionType === 'next') {
      updatedIndex = index + 1;
    } else {
      updatedIndex = barIndex !== undefined ? barIndex : index;
    }
    this.displayManagerService.index$.next(`${updatedIndex}`);
  }

  getCountArray() {
    return [...Array(this.paginator.count ? this.paginator.count : 4).keys()];
  }

  createActionClass(
    index: number,
    type: ActionType,
    actions: Actions | undefined,
    count: number
  ): string {
    const baseClass = `skymiles-landing-section__container__pagination__${type}-action`;
    const checkIndex = type === 'previous' ? index === 0 : index === count - 1;
    return (
      baseClass +
      (actions ? '' : '--no-text') +
      ` ${baseClass}--${checkIndex ? 'disable' : 'enable'}`
    );
  }
}
